// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1UBGV","large":"styles_large__T4PEP"};